(function () {
  if (window.celaFormsReady) return;
  window.celaFormsReady = true;

  var OPENED_AT = Date.now();
  var MIN_DELAY = 2500;
  var UID = 0;

  var style = document.createElement('style');
  style.textContent =
    '.cela-hp{position:absolute!important;left:-9999px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important}' +
    '.cela-error{display:block;flex:1 1 100%;margin-top:6px;font-size:.8125rem;line-height:1.3;color:#a1543f;font-family:var(--font-body--family)}' +
    '.cela-field-invalid{border-color:#c2836f!important;box-shadow:0 0 0 1px rgba(194,131,111,.35)}';
  document.head.appendChild(style);

  function isContactForm(form) {
    var action = form.getAttribute('action') || '';
    return action.indexOf('/contact') > -1;
  }

  function labelFor(field) {
    var name = (field.getAttribute('name') || '').toLowerCase();
    if (name.indexOf('email') > -1) return 'email';
    if (name.indexOf('phone') > -1) return 'phone';
    if (name.indexOf('name') > -1 || name.indexOf('nom') > -1) return 'nom';
    if (name.indexOf('body') > -1 || field.tagName === 'TEXTAREA') return 'message';
    return 'champ';
  }

  function messageFor(field) {
    var kind = labelFor(field);
    var value = (field.value || '').trim();
    if (!value) {
      if (kind === 'email') return 'Indiquez votre adresse e-mail pour qu’on puisse vous répondre.';
      if (kind === 'nom') return 'Indiquez votre nom.';
      if (kind === 'message') return 'Écrivez votre message.';
      if (kind === 'phone') return null;
      return 'Ce champ est nécessaire.';
    }
    if (kind === 'email' && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(value)) {
      return 'Cette adresse e-mail semble incomplète (exemple : prenom@domaine.fr).';
    }
    if (kind === 'nom' && value.length < 2) {
      return 'Indiquez votre nom.';
    }
    if (kind === 'message' && value.length < 10) {
      return 'Ajoutez quelques mots de plus, qu’on comprenne votre demande.';
    }
    if (kind === 'phone' && !/^[0-9+().\-\s]{6,}$/.test(value)) {
      return 'Ce numéro de téléphone semble incorrect.';
    }
    return null;
  }

  /* L'erreur est rattachée au champ lui-même : deux champs peuvent partager
     la même ligne sans que l'un efface le message de l'autre. */
  function clearError(field) {
    field.classList.remove('cela-field-invalid');
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    if (field.celaError && field.celaError.parentNode) {
      field.celaError.parentNode.removeChild(field.celaError);
    }
    field.celaError = null;
  }

  function showError(field, text) {
    clearError(field);
    field.classList.add('cela-field-invalid');
    field.setAttribute('aria-invalid', 'true');
    var p = document.createElement('span');
    p.className = 'cela-error';
    p.textContent = text;
    if (!field.id) field.id = 'cela-champ-' + ++UID;
    p.id = field.id + '-erreur';
    field.setAttribute('aria-describedby', p.id);
    if (field.insertAdjacentElement) {
      field.insertAdjacentElement('afterend', p);
    } else if (field.parentNode) {
      field.parentNode.appendChild(p);
    }
    field.celaError = p;
  }

  function fieldsOf(form) {
    var all = form.querySelectorAll('input, textarea');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var f = all[i];
      var type = (f.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'checkbox') continue;
      if (f.closest('.cela-hp')) continue;
      out.push(f);
    }
    return out;
  }

  function mustCheck(field) {
    var kind = labelFor(field);
    if (field.required) return true;
    if ((field.value || '').trim() !== '') return true;
    return kind === 'email' || kind === 'nom' || kind === 'message';
  }

  function enhance(form) {
    if (form.dataset.celaForm) return;
    form.dataset.celaForm = '1';

    var trap = document.createElement('div');
    trap.className = 'cela-hp';
    trap.setAttribute('aria-hidden', 'true');
    trap.innerHTML =
      '<label>Laissez ce champ vide' +
      '<input type="text" name="contact[site-web]" tabindex="-1" autocomplete="off"></label>';
    form.appendChild(trap);

    fieldsOf(form).forEach(function (f) {
      f.addEventListener('input', function () { clearError(f); });
      f.addEventListener('blur', function () {
        if ((f.value || '').trim() === '' && !f.required) return;
        var m = messageFor(f);
        if (m) showError(f, m); else clearError(f);
      });
    });

    form.addEventListener('submit', function (event) {
      var trapInput = trap.querySelector('input');
      if (trapInput && trapInput.value) {
        event.preventDefault();
        return;
      }

      var champs = fieldsOf(form);

      if (Date.now() - OPENED_AT < MIN_DELAY) {
        event.preventDefault();
        if (champs[0]) showError(champs[0], 'Merci de patienter une seconde avant d’envoyer, puis réessayez.');
        return;
      }

      var invalid = null;
      champs.forEach(function (f) {
        var msg = messageFor(f);
        if (mustCheck(f) && msg) {
          showError(f, msg);
          if (!invalid) invalid = f;
        } else {
          clearError(f);
        }
      });

      if (invalid) {
        event.preventDefault();
        invalid.focus();
        if (invalid.scrollIntoView) invalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  }

  function scan() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isContactForm(forms[i])) enhance(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(scan, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
